import React, { useEffect, useState } from "react";

function App() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  useEffect(() => {
    fetch("/api/logs")
      .then((res) => res.json())
      .then((data) => setLogs(data.reverse()));
  }, []);

  const filteredLogs = logs.filter((log) => {
    const logTime = new Date(log.timestamp).getTime();
    const fromTime = from ? new Date(from).getTime() : 0;
    const toTime = to ? new Date(to).getTime() : Date.now();

    return (
      logTime >= fromTime &&
      logTime <= toTime &&
      (log.ip.includes(filter) ||
        log.path.includes(filter) ||
        (log.reason || "").toLowerCase().includes(filter.toLowerCase()) ||
        (log.ua || "").toLowerCase().includes(filter.toLowerCase()))
    );
  });

  return (
    <div style={{ padding: "2rem", fontFamily: "sans-serif", maxWidth: "1000px", margin: "0 auto" }}>
      <h1 style={{ marginBottom: "1rem" }}>BOT_LOGS Viewer</h1>

      <div style={{ marginBottom: "1.5rem", display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
        <input
          type="text"
          placeholder="Search IP, path, reason, UA..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{ padding: "0.5rem", flex: "1 1 300px" }}
        />
        <input
          type="datetime-local"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          style={{ padding: "0.5rem" }}
        />
        <input
          type="datetime-local"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          style={{ padding: "0.5rem" }}
        />
      </div>

      {filteredLogs.length === 0 ? (
        <p>No logs found.</p>
      ) : (
        filteredLogs.map((log, i) => (
          <div
            key={i}
            style={{
              border: "1px solid #ccc",
              padding: "1rem",
              marginBottom: "1rem",
              backgroundColor: "#f9f9f9",
              borderRadius: "4px",
            }}
          >
            <p><strong>Time:</strong> {log.timestamp}</p>
            <p><strong>IP:</strong> {log.ip}</p>
            <p><strong>Path:</strong> {log.path}</p>
            <p><strong>Reason:</strong> {log.reason}</p>
            <p><strong>User-Agent:</strong> {log.ua || "(none)"}</p>
            <p><strong>Bot Score:</strong> {log.botScore}</p>
            <p><strong>UA Type:</strong> {log.uaType || "unknown"}</p>
          </div>
        ))
      )}
    </div>
  );
}

export default App;
